<template>
    <div class="pageContainer targetPage flexCloumn">
      <el-row class="searchBar flexBetween" style="flex-wrap: wrap;width:100%">
        <div class="flexStart flex_1">
          <tchtree ref="tchtree" v-model="queryForm.class_ids" @change="getList" @changeType="changeType"></tchtree>
          <el-date-picker 
          type="month" 
          value-format="yyyy-MM" 
          v-model="queryForm.year_month"
          :picker-options="pickerOptions"
          @input="changeMonth"
          size="small"
                          placeholder="选择月"
           style="width:200px;margin-right:10px"
           ></el-date-picker>
          <el-input size="small" v-model="queryForm.keyword" clearable placeholder="请输入学生姓名" style="width:200px;margin-right:10px"></el-input>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
  
          <el-button size="small" type="primary" icon="el-icon-download" plain @click="downloadFile">下载班级实习生名册</el-button>
  
        </div>
  
      </el-row>
  
          <div class="dividerBar"></div>
  
          <el-table v-tableFit :data="DataList" height="100%" size="small" stripe border 
          :row-class-name="tableRowClassName" style="width:fit-content;width:100%;">
            <el-table-column type="index" label="序号" width="55" />
            <el-table-column prop="姓名" label="姓名" width="100" />
            <el-table-column prop="性别" label="性别" width="60" />
            <el-table-column prop="年龄" label="年龄" width="60" />
            <el-table-column prop="班级" label="班级" width="80" />
            <el-table-column prop="是否团员" label="是否团员" width="60" >
              <template slot-scope="scope">
                <span>{{ scope.row['政治面貌'] == '团员' ? '是' : '否'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="实习单位" label="实习单位" width="160" />
            <el-table-column prop="实习部门" label="实习部门" width="100" />
            <el-table-column prop="实习岗位" label="实习岗位" width="100" />
            <el-table-column prop="实习时间（起止）" label="实习时间（起止）" width="205" >
              <template slot-scope="scope">
                <span>{{ scope.row['实习开始时间'] }}</span>~
                <span>{{ scope.row['实习结束时间'] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="xinzi" label="实习月薪（元）" width="90" />
            <el-table-column prop="录用意向" label="录用意向" width="60" />
            <el-table-column prop="家庭住址" label="家庭住址" width="250" />
            <el-table-column prop="联系电话" label="联系电话" width="135" />
            <el-table-column prop="备注（父母电话）" label="备注（父母电话）" width="200" >
              <template slot-scope="scope">
                <span v-if="scope.row.jhr1phone">{{ scope.row.jhr1phone }}</span>
                <span v-if="scope.row.jhr1name">（{{ scope.row.jhr1name }}）</span>
              </template>
            </el-table-column>
           
          </el-table>
          <!-- <el-pagination @current-change="handlePageChange" @size-change="handleSizeChange"
            :current-page="Page.current_page" :page-size="Page.per_page" :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next,sizes, jumper" :total="Page.count" style="margin-top: 10px;">
          </el-pagination> -->
          <el-pagination
            :current-page="Page.current_page"
            layout="total" :total="Page.count" style="margin-top: 10px;">
          </el-pagination>
  
  
      
  
  
      <el-dialog :visible.sync="dialogshow" :close-on-click-modal="false" :modal-append-to-body="false"
        :destroy-on-close="true" @close="dialogshow = false" width="800px" custom-class="cus_dialog">
        <div slot="title" class="flexBetween">
          <span style="color: #ffffff;">上传文件</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogshow = false">取消</el-button>
          <el-button type="primary" @click="saveForm">保存</el-button>
        </div>
      </el-dialog>
  
      <!---下载进度--->
      <el-dialog title="下载进度" :visible.sync="showProgress" width="800px" :close-on-click-modal="false">
        <el-progress :text-inside="true" :stroke-width="20" :percentage="progressPercent" :status="progressStatus"></el-progress>
        <span>{{progressMsg}}</span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import tchtree from "@/views/com/tchTree.vue";
  import moment from "moment";
  
  export default {
    components: { tchtree },
    data() {
      return {
        queryForm: {
          keyword: "",
        },
        DataList: [],
        Page: {},
        dialogshow: false,
        year_month: "",
        deptType: 'xx',
  
        showProgress: false,
        progressPercent: 0,
        progressMsg: '',
        progressStatus: 'success',
        timer: null,
        pickerOptions: {
          disabledDate(time) {
            const startDate = new Date(2024,9, 1); // 2020年9月1日
            const endDate = new Date(2025, 6, 1); // 2023年6月1日
            return time.getTime() < startDate.getTime() || time.getTime() >= endDate.getTime();
          }
        }
      }
    },
    mounted() {
      const currentMonth = moment().format('YYYY-MM')
      if(currentMonth > '2025-06'){
        this.queryForm.year_month = '2025-06'
      } else if(currentMonth < '2024-10'){
        this.queryForm.year_month = '2024-10'
      } else {
        this.queryForm.year_month = currentMonth
      }
      this.$nextTick(() => {
        this.getList()
      })
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        // 例如，如果某行满足特定条件（例如，名字为“王小虎”）则高亮该行
        if (row.xinzi < 2490) {
          return 'warning-row';
        }else{
          return ''; // 不满足条件则不返回任何类名或返回空字符串
  
        }
      },
      changeMonth(e) {
        console.log(139,e)
        this.queryForm.year_month = e
        this.getList()
      },
      getSize(size) {
        if (size) {
          if (size < 1024) {
            return size + "B"
          } else if (size >= 1024 && size < 1024 * 1024) {
            return parseInt(size / (1024) * 10) / 10 + "KB"
          } else if (size >= 1024 * 1024 && size < 1024 * 1024 * 1024) {
            return parseInt(size / (1024 * 1024) * 10) / 10 + "MB"
          } else if (size >= 1024 * 1024 * 1024 && size < 1024 * 1024 * 1024 * 1024) {
            return parseInt(size / (1024 * 1024 * 1024) * 10) / 10 + "GB"
          }
        } else {
          return "-"
        }
      },
      getList() {
        let arr = this.queryForm.year_month ? this.queryForm.year_month.split('-') : []
        this.$http.post("/api/month_report_list_view_mingce", {
          page: this.Page.current_page,
          pagesize: this.Page.per_page,
          keyword: this.queryForm.keyword,
          report_year: arr.length ? arr[0] : '',
          report_month: arr.length ? arr[1] : '',
          class_ids: this.queryForm.class_ids,
        }).then(res => {
          this.DataList = res.data
          this.Page.count = res.data.length
        })
      },
      openFile(e) {
        if (e.url) {
          //window.open(e.url, "_blank")
          this.$http.get(e.url, {
            responseType: 'arraybuffer'
          }).then(r => {
            var blob = new Blob([r.data], { type: 'application/octet-stream;charset=UTF-8' })
            var downloadElement = document.createElement('a')
            var href = window.URL.createObjectURL(blob) // 创建下载的链接
            downloadElement.style.display = 'none'
            downloadElement.href = href
            downloadElement.download = decodeURIComponent(e.filename) // 下载后文件名
            document.body.appendChild(downloadElement)
            downloadElement.click() // 点击下载
            document.body.removeChild(downloadElement) // 下载完成移除元素
            window.URL.revokeObjectURL(href)
          })
        }
      },
      deleteFile(e) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("/api/month_report_delete", {
            id: e.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getList()
          })
  
        }).catch(() => {
  
        });
      },
      saveForm() {
        if (this.sendToAll) {
          this.formData.target_teachers = "all";
          this.formData.target_classes = "all";
        } else {
          //发送对象
          if (this.allStudent) {
            this.formData.target_classes = "all"
          }
  
          if (this.allTeacher) {
            this.formData.target_teachers = "all"
          }
        }
        let item = JSON.parse(JSON.stringify(this.formData));
        if (!item.files.length) {
          return this.$message.error('请上传文件')
        }
        let saveFile = idx => {
          if (idx < item.files.length) {
            let file = item.files[idx]
            let formData = {
              pid: this.pid,
              ftype: "file",
              filetype: file.filetype,
              filename: file.fileName,
              filesize: file.size,
              url: file.src,
              is_share: 1,
              target_classes: item.target_classes,
              target_teachers: item.target_teachers,
            }
            this.$http.post('/api/t_sch_filesstore_edit', formData).then(res => {
              saveFile(idx + 1)
            });
          } else {
            this.dialogshow = false
            this.$message({
              type: 'success',
              message: '保存成功'
            });
            this.getList()
          }
        }
        saveFile(0)
      },
      changeType(val) {
        this.deptType = val
      },
      handlePageChange(e) {
        this.Page.current_page = e
        this.getList()
      },
      handleSizeChange(e) {
        this.Page.per_page = e
        this.getList()
      },
      
      downloadFile() {
        if (!this.queryForm.class_ids) {
          return this.$message.error('请选择班级/系部')
        }
        let arr = this.queryForm.year_month ? this.queryForm.year_month.split('-') : []
        this.showProgress = true
        this.progressMsg = '准备文件中，请稍等...'
        this.progressPercent = 0
        this.progressStatus = 'success'
        this.$http.post('/api/monthReportSingleDownload', {
          report_year: arr.length ? arr[0] : '',
          report_month: arr.length ? arr[1] : '',
          report_type: 'sxmc',
          class_ids: this.queryForm.class_ids,
        }).then(res => {
          if (res.data.url) {
            this.showProgress = false;
            window.open(res.data.url,'_blank')
            return;
          }
          //轮询获取进度
          this.timer = setInterval(() => {
            this.$http.get(`/api/progress_status?progress_mark=${res.data.progress_mark}`).then(res => {
              let data = res.data.data
              if (data.indexOf('done') > -1) {
                let fileUrl = data.substring(data.indexOf('-')+1)
                this.progressMsg = '压缩完成，正在下载'
                this.progressPercent = 100;
                setTimeout(() => {
                  this.showProgress = false;
                  window.open(fileUrl,'_blank')
                },500)
                clearInterval(this.timer)
              } else if (data.indexOf('compress') > -1) {
                this.progressPercent =  Number(data.substring(data.indexOf('-') + 1))
                this.progressMsg = '正在打包压缩文件，过程有点长，请稍等...'
              } else if (data == 'failed') {
                this.progressMsg = '下载失败，请重新下载'
                this.progressStatus = 'exception'
                clearInterval(this.timer)
              } else {
                this.progressPercent = Number(data)
              }
            }).catch(e => {
              clearInterval(this.timer)
            })
          },2000)
        }).catch(() => {
          this.showProgress = false;
        })
      }
      
    },
    beforeRouteUpdate(to, from, next) {
      this.queryForm.keyword = ""
      this.queryForm.year_month = to.params.month
      this.$refs.tchtree.clearEmpty()
      next()
    }
  
  };
  </script>
   <style>
  .el-table .warning-row td {
    background-color: #f8ddc9 !important;
  }</style>
  <style scoped>
  
  .filerow {
    padding: 10px;
    height: 30px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    line-height: 30px;
    display: flex;
    color: #333;
  }
  
  .filerow:hover {
    background-color: aliceblue;
  }
  
  
  .filename {
    width: 30%;
    padding-left: 10px;
  }
  
  .filedate {
    width: 120px;
    font-size: 12px;
  }
  
  .headimg {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    vertical-align: middle;
  }
  
  .typeicon {
    width: 25px;
    height: 25px;
    border-radius: 4px;
    vertical-align: middle;
  }
  
  .filenameitem {
    position: relative;
  }
  
  .fileicon {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    color: #409EFF;
    display: block;
  }
  
  .filenameitem:hover .fileicon {
    display: block;
  }
  
  .filenameitem:hover {
    color: #409EFF;
    cursor: pointer;
  }
  
  .nextpath {
    font-size: 14px;
    color: #409EFF;
    cursor: pointer;
  }
  </style>